import React from 'react';
import {Helmet} from 'react-helmet';

import {Survey} from '../Services/SurveyService';

interface SurveyWidgetProps {
  survey?: Survey;
}

function SurveyWidget({survey}: SurveyWidgetProps) {
  if (survey === undefined || survey === null) {
    return <div />;
  }

  return (
    <div className="sidebar-widget-area">
      <h5 className="title">Surveys</h5>
      <div className="widget-content">
        <div id="smcx-sdk"></div>
        <Helmet>
          <script src={`https://widget.surveymonkey.com/collect/website/js/${survey.embedCode}.js`} type="text/javascript" />
        </Helmet>
      </div>
    </div>
  );
}

export default SurveyWidget;
